import { supabase } from './supabase'

// ── Referral model ──────────────────────────────────────────────────────────
// A referred couple QUALIFIES the referrer only when the referred couple PAYS
// for Premium. The reward (₦3,000 → referrer's wallet) and qualification are
// handled SERVER-SIDE in the verify-payment edge function — tamper-proof, no
// activation cliff (the first qualified referral pays out immediately). The
// wallet credit is redeemable as a discount on the referrer's own Premium
// upgrade. This file only handles capturing the code and linking the referral.

// Store referral code from URL when someone visits signup
export function captureReferralCode() {
  const params = new URLSearchParams(window.location.search)
  const ref = params.get('ref')
  if (ref) {
    localStorage.setItem('okoiya_ref', ref)
  }
}

// After a new wedding is created, link it to the referrer (creates the pending
// referral row; it becomes qualified + credited server-side once this couple
// upgrades to Premium).
export async function linkReferral(newUserId, newWeddingId) {
  const refCode = localStorage.getItem('okoiya_ref')
  if (!refCode) return

  // Find the referrer's wedding by referral code
  const { data: referrerWedding } = await supabase
    .from('weddings')
    .select('id')
    .eq('referral_code', refCode)
    .maybeSingle()

  if (!referrerWedding || referrerWedding.id === newWeddingId) return

  // Check not already linked
  const { data: existing } = await supabase
    .from('referrals')
    .select('id')
    .eq('referred_user_id', newUserId)
    .maybeSingle()

  if (existing) return

  await supabase.from('referrals').insert({
    referrer_wedding_id: referrerWedding.id,
    referred_user_id: newUserId,
    referred_wedding_id: newWeddingId,
  })

  localStorage.removeItem('okoiya_ref')
}
